import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { ButtonController, IButtonControllerOptions } from "../../../Common/ButtonController";
import { GameLogic } from "../../../Logic/GameLogic";
import { BoosterTypeEnum, GameModel } from "../../../Models/GameModel";

export interface IShopMegaPackControllerOptions {
    money?: number,
    leaves?: number,
    price?: number,
    boosterHook: number,
    boosterLine: number,
    boosterBrush: number
}

export class ShopMegaPackController extends AnimationBaseController {
    $model: GameModel;

    private labelPriseText: string;

    public constructor(
        @Inject private _options: IShopMegaPackControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('ShopMegaPackController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn_buy: {
                    instanceName: 'btn_big_folder',
                    controller: ButtonController,
                    options: <IButtonControllerOptions> {
                        onClick: (status: boolean) => {
                            this._gameLogic.addBooster(BoosterTypeEnum.yarn, this._options.boosterBrush);
                            this._gameLogic.addBooster(BoosterTypeEnum.needle, this._options.boosterLine);
                            this._gameLogic.addBooster(BoosterTypeEnum.hook, this._options.boosterHook);
                            // this._gameLogic.addBalanceLeaves(1); TODO refactoring
                            this._gameLogic.addBalanceCoins(-this._options.price);
                        },
                        onFreameSet: (frame: number) => {
                            this.setSizeLabelButton(frame);
                        }
                    }
                }
            },
            modelWatch: {
                userBalanceCoins: () => {
                    this.checkCoins();
                }
            }
        };
    }

    protected onInitialize() {
        this.checkCoins();
        this.labelPriseText = this._options.price.toFixed();

        const btnLabel = this.getDisplayObjectByQuery('btn_big_folder.txt')[0] as PIXI.Text;
        btnLabel.text = this.labelPriseText;
    }

    private checkCoins() {

        if (this._options.price > this.$model.userBalanceCoins) {
            this.$childControllers.get<ButtonController>('btn_buy').disabled();
        } else {
            this.$childControllers.get<ButtonController>('btn_buy').enabled();
        }
    }

    private setSizeLabelButton(frame: number) {
        const btnLabel = this.getDisplayObjectByQuery('btn_big_folder.txt')[0] as PIXI.Text;

        btnLabel.scale.set(frame === 1 ? 1.2 : 1);
        btnLabel.x = -btnLabel.width / 2;
        btnLabel.y = -btnLabel.height / 2;
    }
}
